import React, { useContext, useEffect, useState } from 'react';
import BrokerFields from './brokerFields';
import { AddSaveBrokerDto, addPackageComodity } from '../../../types';
import { useShipForm } from '../../../context/shipForms';
import {
  AddBrokerInitialValues,
  AddBrokerValidationValues,
  addPackageComodityInitialValue,
  editBrokerValidationValues,
} from '../../../initial-values';
import { savedBrokersList } from '../../../api/privateApis';
import SearchDropdown from '../../global-components/searchDropdown';
import { isValidationValidated } from '../../../utils/helper';
import ComodityFields from './comodityFields';
import { useSnackbar } from 'notistack';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { useAccordionButton } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import plusIcon from '../../../assets/icons/plus.svg';
import accUpIcon from '../../../assets/icons/new_icon/ArrowUpWhite.svg';
import accDownIcon from '../../../assets/icons/new_icon/ArrowDownWhite.svg';
import { useLocation } from 'react-router-dom';
interface Props {
  setShowRatesForm: any;
  setCurrentShipmentStatus: any;
  setShowInternationScreenForm: any;
}
function MainInternationalPage({
  setShowRatesForm,
  setCurrentShipmentStatus,
  setShowInternationScreenForm,
}: Props) {
  const {
    getBrokerFormDataContext,
    getRatesApiPayloadContext,
    setBrokerFormDataContext,
    setRatesApiPayloadContext,
    setSelectedRateContext,
    setAllCommoditiesContext,
  } = useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const isAddLeg = location.pathname === '/app/add-leg';
  const brokerFormContextData = getBrokerFormDataContext();
  const ratesApiPayloadContextData = getRatesApiPayloadContext();
  const [addBrokerForm, setAddBrokerForm] = useState<AddSaveBrokerDto>(
    brokerFormContextData ? brokerFormContextData : AddBrokerInitialValues
  );
  const [packagesList, setPackagesList] = useState<any>(
    ratesApiPayloadContextData?.packages
  );
  const [savedBrokers, setSavedBrokers] = useState<any>([]);
  const [addBrokerValidations, setAddBrokerValidations] = useState(
    brokerFormContextData
      ? editBrokerValidationValues
      : AddBrokerValidationValues
  );
  const [validating, setValidating] = useState<any>(false);
  const [initalComodity, setInitialComodity] = useState<addPackageComodity>(
    addPackageComodityInitialValue
  );

  const roundToTwoDecimalPlaces = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  };

  function backHandle() {
    if (isAddLeg) {
      setShowInternationScreenForm(false);
      setCurrentShipmentStatus('select-route');
    } else {
      setShowInternationScreenForm(false);
      setCurrentShipmentStatus('packages');
    }
  }
  function nextHandle() {
    setValidating(true);
    if (!isValidationValidated(addBrokerValidations)) {
      enqueueSnackbar('Please fill Broker form.', {
        variant: 'error',
      });
      return;
    }

    const hasInvalidCommodityValidation =
      packagesList &&
      packagesList.some((pkg: any) =>
        pkg.commodities.some(
          (commodity: any) => !isValidationValidated(commodity.validations)
        )
      );

    if (hasInvalidCommodityValidation) {
      enqueueSnackbar('Please fill all commodity details.', {
        variant: 'error',
      });
      return;
    }
    const isWeightValid =
      packagesList &&
      packagesList.every((pkg: any) => {
        let cSum = pkg.commodities.reduce(
          (sum: any, commodity: any) =>
            sum + parseFloat(commodity.total_weight),
          0
        );
        cSum = roundToTwoDecimalPlaces(cSum);

        // Round the weight as well before comparison
        const pkgWeight = roundToTwoDecimalPlaces(parseFloat(pkg.weight));

        return pkgWeight === cSum;
      });

    if (!isWeightValid) {
      enqueueSnackbar(
        'Total weight in packages should match the sum of commodity weights.',
        {
          variant: 'error',
        }
      );
      return;
    }
    const updatedPackagesList = packagesList.map((pkg: any) => ({
      ...pkg,
      commodities: pkg.commodities.map(
        ({ validations, item_id, total_weight, ...commodityRest }: any) => ({
          ...commodityRest,
          total_weight: Number(total_weight),
        })
      ),
    }));

    const allCommodities =
      updatedPackagesList &&
      updatedPackagesList.reduce((commoditiesArray: any[], pkg: any) => {
        return [...commoditiesArray, ...pkg.commodities];
      }, []);
    setAllCommoditiesContext(allCommodities);
    //in packagesList array each item contains array of commodities and each item of commodities contain validations object, check if any of that is false then return
    //if the upper condition is true then :
    //in packagesList each item contains weight,
    //in each item of packagesList there is in array of commodities and each item of commodities contain total_weight
    //check if that weight is equal to the sum of all the total_weight of commodities array

    //remove validations and item_id from commodities array of each item packagesList
    setSelectedRateContext(null);
    setRatesApiPayloadContext({
      ...ratesApiPayloadContextData,
      packages: updatedPackagesList,
    });
    setBrokerFormDataContext(addBrokerForm);
    setShowRatesForm(true);
    setShowInternationScreenForm(false);
  }

  function mapSelectedBroker(item: any) {
    setAddBrokerForm({
      ...addBrokerForm,
      contact: {
        ...addBrokerForm.contact,
        company_name: item?.contact?.company_name,
        name: item?.contact?.name,
        phone: item?.contact?.phone,
        email: item?.contact?.email,
      },
      address: {
        ...addBrokerForm.address,
        address: item?.address?.address,
        address_two: item?.address?.address_two,
        city: item?.address?.city,
        country: item?.address?.country,
        province: item?.address?.province,
        postal_code: item?.address?.postal_code,
        has_shipping_bays: item?.address?.has_shipping_bays,
      },
    });
  }
  function getSavedBrokers() {
    savedBrokersList({ is_pagination: false })
      .then((response: any) => {
        if (!response?.data?.is_error) {
          let inputData = response?.data?.content;
          const transformedData = inputData.map((item: any) => ({
            label: `${item.contact.name}, ${item.address.city}, ${item.address.country}`,
            value: item,
          }));
          setSavedBrokers(transformedData);
        }
      })
      .catch((e) => {});
  }
  useEffect(() => {
    getSavedBrokers();
  }, []);

  function addCommodity(itemId: any, pkgId: any) {
    const packageIndex = packagesList.findIndex(
      (item: any) => item.item_id === itemId
    );
    if (packageIndex !== -1) {
      const newInitialCommodity = {
        ...initalComodity,
        package_id: pkgId,
        item_id: itemId,
      };
      const updatedList = [...packagesList];
      const updatedPackage = {
        ...updatedList[packageIndex],
        commodities: [
          ...updatedList[packageIndex].commodities,
          newInitialCommodity,
        ],
      };
      updatedList[packageIndex] = updatedPackage;
      setPackagesList(updatedList);
    }
  }

  function deleteCommodity(itemId: any, index: any) {
    const updatedList =
      packagesList &&
      packagesList.map((packageItem: any) => {
        if (packageItem.item_id === itemId) {
          const updatedCommodities = packageItem.commodities.filter(
            (_: any, commodityIndex: any) => commodityIndex !== index
          );

          return {
            ...packageItem,
            commodities: updatedCommodities,
          };
        }
        return packageItem;
      });

    setPackagesList(updatedList);
  }

  useEffect(() => {
    if (packagesList && packagesList.length > 0) {
      const updatedPackagesList = packagesList.map((item: any) => {
        const initialCommodityWithUpdatedPackageId = {
          ...initalComodity,
          package_id: item?.package_id || null,
          item_id: item?.item_id,
        };

        return {
          ...item,
          commodities: item?.commodities
            ? item?.commodities
            : [initialCommodityWithUpdatedPackageId],
        };
      });
      setPackagesList(updatedPackagesList);
    }
  }, []);

  const updateCommodity = (updatedCommodity: any) => {
    setPackagesList((prevPackagesList: any) => {
      return prevPackagesList.map((packageItem: any) => {
        if (packageItem.item_id === updatedCommodity.item_id) {
          return {
            ...packageItem,
            commodities: packageItem.commodities.map(
              (commodity: any, index: any) => {
                if (index === updatedCommodity.index) {
                  return {
                    ...commodity,
                    ...updatedCommodity,
                  };
                }
                return commodity;
              }
            ),
          };
        }
        return packageItem;
      });
    });
  };

  function CustomToggle({ children, eventKey, pkg, callback }: any) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );
    const isCurrentEventKey = activeEventKey === eventKey;
    return (
      <div className='accordian-header d-flex justify-content-between'>
        <button
          className='border-0 bg-transparent lex-18-400 color-white'
          onClick={decoratedOnClick}
        >
          {children}
        </button>
        <div className='d-flex'>
          <button
            type='button'
            className='d-flex align-items-center border-0 bg-transparent'
            onClick={() => {
              addCommodity(pkg?.item_id, pkg?.package_id);
            }}
          >
            <img src={plusIcon} alt='plus icon' />
            <span className='ms-1 color-white'>Add Commodity</span>
          </button>
          <button
            type='button'
            className='border-0 bg-transparent'
            onClick={decoratedOnClick}
          >
            <img
              src={isCurrentEventKey ? accUpIcon : accDownIcon}
              alt='plus icon'
            />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div id='international_section'>
      <div className='ubbe-card mt-5'>
        <div className='ubbe-card-header'>
          <h5 className='ps-3 mb-0 GlobalBoxHead'>
            Customs Broker{' '}
            <span className='lex-black-16-400 color-white'>
              (The broker address must match the destination country)
            </span>
          </h5>
        </div>
        <div className='card-body p-4'>
          <div className='row'>
            <div className='col-sm-12 col-md-4 my-auto'>
              <SearchDropdown
                id={'saved_brokers'}
                dontShowAlreadySelected={true}
                options={savedBrokers && savedBrokers}
                onSelect={(item) => {
                  if (item?.value !== '') {
                    mapSelectedBroker(item.value);
                    setAddBrokerValidations(editBrokerValidationValues);
                  }
                }}
              />
            </div>
          </div>
          <BrokerFields
            formData={addBrokerForm}
            setFormData={setAddBrokerForm}
            formValidations={addBrokerValidations}
            setFormValidations={setAddBrokerValidations}
            validating={validating}
          />
        </div>
      </div>
      <div className='ubbe-card mt-5'>
        <div className='ubbe-card-header'>
          <h5 className='ps-3 mb-0 GlobalBoxHead'>
            Package Commodities
            <span className='lex-black-16-400 color-white me-1'>
              (Please ensure that the weight of all commodities is equal to the
              total weight of the package)
            </span>
          </h5>
        </div>
        <div className='card-body p-4'>
          <Accordion defaultActiveKey='0'>
            {packagesList &&
              packagesList.length > 0 &&
              packagesList.map((pkg: any, key: any) => (
                <>
                  <Card style={{ marginBottom: '20px' }}>
                    <Card.Header className='accordian-card-header-main'>
                      <CustomToggle eventKey={key} pkg={pkg}>{`${
                        pkg?.package_type
                      } of ${pkg?.description} - ${pkg?.quantity} @ ${
                        pkg?.length
                      } ${pkg?.is_metric ? 'cm' : 'in'} x ${pkg?.width} ${
                        pkg?.is_metric ? 'cm' : 'in'
                      } x ${pkg?.height} ${pkg?.is_metric ? 'cm' : 'in'} - ${
                        pkg?.weight
                      } ${pkg?.is_metric ? 'kg' : 'lbs'}`}</CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={key}>
                      <Card.Body>
                        {pkg?.commodities &&
                          pkg.commodities.length > 0 &&
                          pkg.commodities.map((item: any, index: any) => (
                            <ComodityFields
                              data={item}
                              index={index}
                              deleteCommodity={() =>
                                deleteCommodity(pkg?.item_id, index)
                              }
                              updateCommodity={(updatedCommodity: any) =>
                                updateCommodity({
                                  ...updatedCommodity,
                                  item_id: pkg?.item_id,
                                  index,
                                })
                              }
                            />
                          ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </>
              ))}
          </Accordion>
        </div>
      </div>
      <div className='row mt-5'>
        <div className='col-4 col-lg-2'>
          <p
            className='btn btn-ubbe-new-back d-flex gap-2'
            onClick={backHandle}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </p>
        </div>
        <div className='col-4 col-lg-8'></div>
        <div className='col-4 text-end col-lg-2'>
          <p className='btn btn-ubbe-new-blue' onClick={nextHandle}>
            Continue
          </p>
        </div>
      </div>
    </div>
  );
}

export default MainInternationalPage;
